var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    width: "40px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M855.3,244.8c-0.1-4.5-1.5-8.9-4.6-12.4L661.8,16.6c-0.1-0.1-0.1-0.1-0.2-0.1c-1.1-1.3-2.4-2.3-3.8-3.2c-0.4-0.3-0.8-0.5-1.3-0.8c-1.2-0.7-2.5-1.2-3.8-1.6c-0.4-0.1-0.7-0.3-1-0.3c-1.4-0.3-2.9-0.6-4.4-0.6H182.9c-21.2,0-38.4,17.2-38.4,38.4v903.1c0,21.2,17.2,38.4,38.4,38.4h634.1c21.2,0,38.4-17.2,38.4-38.4V247C855.5,246.3,855.4,245.6,855.3,244.8z M306.4,876.5c-17.6,14.6-44.3,21.5-77,21.5c-19.6,0-33.4-1.2-42.8-2.5V731.6c13.9-2.2,31.9-3.5,51-3.5c31.7,0,52.2,5.7,68.3,17.8c17.3,12.9,28.2,33.4,28.2,62.9C334.2,840.8,322.5,862.9,306.4,876.5z M429.8,899c-49.5,0-78.5-37.4-78.5-84.9c0-50,31.9-87.4,81.2-87.4c51.3,0,79.2,38.4,79.2,84.4C511.7,865.8,478.5,899,429.8,899z M621.9,867.6c11.4,0,24-2.5,31.4-5.4l5.7,29.5c-6.9,3.5-22.5,7.2-42.8,7.2c-57.7,0-87.4-35.9-87.4-83.4c0-57,40.6-88.7,91.1-88.7c19.6,0,34.4,4,41.1,7.4l-7.7,30c-7.7-3.2-18.3-6.2-31.7-6.2c-30,0-53.2,18.1-53.2,55.2C568.4,846.5,588.3,867.6,621.9,867.6z M772.5,896.3l-15.1-30.2c-6.2-11.6-10.2-20.3-14.9-30H742c-3.5,9.7-7.7,18.3-12.9,30l-13.9,30.2h-43.1l48.3-84.4l-46.5-82.4h43.3l14.6,30.5c4.9,10.1,8.7,18.3,12.6,27.7h0.5c4-10.6,7.2-18.1,11.4-27.7l14.1-30.5h43.1l-47,81.5l49.5,85.4L772.5,896.3L772.5,896.3L772.5,896.3z M182.9,662.5V48.4h445.2v196.6c0,10.6,8.6,19.2,19.2,19.2h169.8v398.3L182.9,662.5L182.9,662.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.6,757.1c-8.4,0-13.9,0.8-17.1,1.5v109.2c3.2,0.7,8.4,0.7,13.1,0.7c34.2,0.3,56.4-18.6,56.4-58.4C294.3,775.5,274,757.1,241.6,757.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.5,756.7c-25.5,0-40.3,24.3-40.3,56.7c0,32.7,15.4,55.7,40.6,55.7c25.5,0,40.1-24.3,40.1-56.7C471.8,782.4,457.5,756.7,431.5,756.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M618.4,331.3V222.2H243.7V488h109.1v109.1h374.7V331.3H618.4z M352.8,468.8h-89.9V241.4h336.3v89.9H352.8V468.8z M708.3,577.9H372V350.5h336.3V577.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.7,
    cy: 391.3,
    r: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.2,
    y: 386.5,
    width: 195.4,
    height: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.7,
    cy: 437.8,
    r: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.2,
    y: 433,
    width: 195.4,
    height: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.7,
    cy: 487.8,
    r: 12.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.2,
    y: 482.9,
    width: 195.4,
    height: 9.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.7,522.2c7.1,0,12.8,5.7,12.8,12.8c0,7.1-5.7,12.8-12.8,12.8c-7.1,0-12.8-5.7-12.8-12.8C413.9,527.9,419.6,522.2,426.7,522.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.2,
    y: 530.2,
    width: 195.4,
    height: 9.6
  })))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDox);
export default __webpack_public_path__ + "static/media/dox.6f6185a1.svg";
export { ForwardRef as ReactComponent };